enum PERIODS_DEFINITION {
  MONTH = 'P1M',
  QUARTER = 'P3M',
  YEAR = 'P1Y',
  ALL = '',
}

interface SinglePeriod {
  type: PERIODS_DEFINITION;
  active: boolean;
  label: string;
  supportsComparison: boolean;
}

const getPeriods = (reportType): SinglePeriod[] => {
  const reportTypeRequiresComparison = reportType?.comparison ?? true;

  return [
    {
      type: PERIODS_DEFINITION.MONTH,
      active: false,
      label: 'Monthly',
      supportsComparison: true,
    },
    {
      type: PERIODS_DEFINITION.QUARTER,
      active: false,
      label: 'Quarterly',
      supportsComparison: true,
    },
    {
      type: PERIODS_DEFINITION.YEAR,
      active: false,
      label: 'Yearly',
      supportsComparison: true,
    },
  ]
    .filter(
      (periodDefinition) => periodDefinition.supportsComparison || !reportTypeRequiresComparison
    )
    .filter((periodDefinition) =>
      reportType?.periods ? reportType.periods.includes(periodDefinition.type) : true
    );
};

export { PERIODS_DEFINITION, SinglePeriod, getPeriods };
